import { render, staticRenderFns } from "./UmkScrap.vue?vue&type=template&id=71f20bfa&scoped=true&"
import script from "./UmkScrap.vue?vue&type=script&lang=js&"
export * from "./UmkScrap.vue?vue&type=script&lang=js&"
import style0 from "./UmkScrap.vue?vue&type=style&index=0&id=71f20bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f20bfa",
  null
  
)

export default component.exports